<template>
    <div class="checkout__accordion" v-if="!hide">
        <a href="#" class="checkout__accordion__title  checkout__accordion__title--done" v-if="completed" @click="edit">{{ __('Please select a payment method') }}</a>
        <span class="checkout__accordion__title" v-else-if="!completed">{{ __('Please select a payment method') }}</span>

        <div v-if="!completed">
            <div class="checkout__methods">
               
                <a href="#" class="checkout__methods__item" v-for="(m, i) in methods" @click="submit($event, m.handle)" v-bind:class="{'active': method == m.handle}">
                    <span v-if="m.name == 'Stripe'">Credit/Debit card</span>
                    <span v-else>{{ m.name }}</span>
                </a>

            </div>

           
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            completed: {
                type: Boolean,
                required: true
            }
        },

        data: () => ({
            hide: false,
            method: '',
            methods: []
        }),

        mounted() {
            this.$emit('loading', true);

            axios.get('/checkout/methods').then(response => {
                this.methods = response.data;
                if(this.methods.length == 1) {
                    this.hide = true;
                    this.method = this.methods[0].handle;
                    this.$emit('next');
                }
                this.$emit('loading', false);
            });
        },

        methods: {
            submit(event, handle) {
                event.preventDefault();
                this.method = handle;
                this.$emit('next');
            },

            edit() {
                event.preventDefault();
                this.method = '';
                this.$emit('edit', true);
            }
        },

        watch: {
            method: function(handle) {
                this.$emit('update', handle);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Methods.vue